export function Cargando({ texto = "Cargando..." }: { texto?: string }) {
  return (
    <div className="flex items-center justify-center gap-2 py-16 text-sm text-texto-secundario">
      <span className="h-4 w-4 animate-spin rounded-full border-2 border-borde border-t-texto-secundario" />
      {texto}
    </div>
  );
}
